import React from 'react';
import { DialogActions, Button } from '@mui/material';

interface DialogActionButtonsProps {
    isEditing: boolean;
    isLoading: boolean;
    isSaving: boolean;
    isDeleting: boolean;
    onCancel: () => void;
    onDelete: () => void;
    onSave: () => void;
}

export const DialogActionButtons: React.FC<DialogActionButtonsProps> = ({
    isEditing,
    isLoading,
    isSaving,
    isDeleting,
    onCancel,
    onDelete,
    onSave
}) => {
    return (
        <DialogActions>
            <Button onClick={onCancel} disabled={isLoading}>
                Cancel
            </Button>
            {isEditing && (
                <Button
                    onClick={onDelete}
                    color="error"
                    disabled={isLoading}
                >
                    {isDeleting ? 'Deleting...' : 'Delete'}
                </Button>
            )}
            <Button
                onClick={onSave}
                variant="contained"
                disabled={isLoading}
            >
                {isSaving ? 'Saving...' : 'Save'}
            </Button>
        </DialogActions>
    );
};
